var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckedSmallIcon = function SvgCheckedSmallIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8617 0.729544C10.6787 0.545881 10.3786 0.545881 10.1957 0.729544L4.65549 6.26837L1.80232 3.39569C1.61933 3.21135 1.3213 3.21135 1.13696 3.39569L0.137243 4.39473C-0.0457476 4.57705 -0.0457476 4.8771 0.137243 5.06076L4.31978 9.27089C4.50277 9.45321 4.80081 9.45321 4.98582 9.27089L11.8607 2.39529C12.0464 2.21163 12.0464 1.91091 11.8607 1.72657L10.8617 0.729544Z",
    fill: "#999999"
  })));
};
export default SvgCheckedSmallIcon;